import React from 'react';
import PropTypes from 'prop-types';

import TableData from './TableData';
import TableRow from './TableRow';

const EmptyTable = ({ colSpan, text }) => {
  return (
    <TableRow>
      <TableData colSpan={colSpan}>
        <div className="text-center">{text}</div>
      </TableData>
    </TableRow>
  );
};

EmptyTable.propTypes = {
  colSpan: PropTypes.number,
  text: PropTypes.string,
};

EmptyTable.defaultProps = {
  colSpan: 1,
  text: 'Table Empty'
};

export default EmptyTable;
